import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC7gcch0amSUqGsLk_VUWOfk7u1Tf6Se0I",
  authDomain: "vinla-4ba8c.firebaseapp.com",
  projectId: "vinla-4ba8c",
  storageBucket: "vinla-4ba8c.appspot.com",
  messagingSenderId: "544434546475",
  appId: "1:544434546475:web:6084d07345c6afc9bdc76e",
  measurementId: "G-2N95DQ0N3H"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();

